import { get } from 'lodash';

export const domainsOverviewIsLoading = state => get( state, 'domainsOverview.isLoading', false );
export const domainsOverviewDataSelector = state => get( state, 'domainsOverview.data', {} );
export const claimedDomainsOverviewSelector = state => get( state, 'domainsOverview.data.approved', {} );
export const discoveredDomainsOverviewSelector = state => get( state, 'domainsOverview.data.unclaimed', {} );
